<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!-- 차기교정기간 -->
				<el-col :span="5">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001547') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
						/>
					</div>
				</el-col>
				<!-- 장비명 -->
				<el-col :span="4">
					<search-input
						:label="`${getMessage_('QWCC001314')} / ${getMessage_('QWCC001317')}`"
						paramKey="mesEqipNm"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="searchParams.mesEqipNm"
					>
					</search-input>
				</el-col>
				<!-- 교정업체 -->
				<el-col :span="4">
					<select-combo
						:label="getMessage_('QWCC001579')"
						paramKey="calInstCd"
						:options="calInstCdList"
						:propData="searchParams.calInstCd"
						@commChange="setSearchParam"
						:showAll="true"
						:disabled="!isMmcAdmin && isMmcGuest"
					></select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mmc/mmcm/MesCal/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';
export default {
	props: { scrId: { type: String, default: '' } },
	components: { SearchInput, SelectCombo },
	data() {
		return {
			searchDateRange: []
		};
	},
	async created() {
		this.$sf_toggleLoading(true);
		this.searchDateRange = [...this.getSearchMonths_];
		await this.getCommCodesOnce_(); //공통코드 한번에 부르기
		await this.getMmcInstList_(); //교정업체 정보는 '부서관리'에서 관리함
		if (!this.isMmcAdmin && this.isMmcGuest) {
			//외부 업체 권한 체크
			!!this.IsInclCpny_ && this.setSearchParam_({ key: 'calInstCd', value: this.IsInclCpny_ });
		}
		await this.searchList();
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				if (!this.isMmcAdmin && this.isMmcGuest && !this.searchParams.calInstCd) {
					throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				}
				await this.getMesList_();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setSearchParam_({ key: 'strDt', value: '' });
				this.setSearchParam_({ key: 'endDt', value: '' });
			}
			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				this.setSearchParam_({ key: 'strDt', value: strDt });
				this.setSearchParam_({ key: 'endDt', value: endDt });
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
